import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

const initialState = {
  bonuses: [],
  bonusAmounts: [],
  lockedBonusProgress: [],
  lockedBonusProgressMeta: null,
  loading: false,
  error: null,
};


export const getBonusesAmountsAsync = createAsyncThunk("user/getBonusesAmounts", async () => {
  const response = await axiosInstance.post("/user/getBonusAmounts",{});
  return response.data;
});

export const getLockedBonusProgressAsync = createAsyncThunk("user/getLockedBonusProgress", async () => {
  const response = await axiosInstance.post("/user/getLockedBonusProgress",{});
  return response.data;
});



export const bonusSlice = createSlice({
  name: "bonus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBonusesAmountsAsync.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBonusesAmountsAsync.fulfilled, (state, action) => {
      state.bonusAmounts = action.payload;
      state.loading = false;
    });
    builder.addCase(getBonusesAmountsAsync.rejected, (state, action) => {
      state.error = action.payload || action.error?.message || "Failed to load bonus amounts";
      state.loading = false;
    });

    builder.addCase(getLockedBonusProgressAsync.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getLockedBonusProgressAsync.fulfilled, (state, action) => {
      state.lockedBonusProgress = action.payload?.data || [];
      state.lockedBonusProgressMeta = action.payload?.extras || null;
      state.loading = false;
    });
    builder.addCase(getLockedBonusProgressAsync.rejected, (state, action) => {
      state.error = action.payload || action.error?.message || "Failed to load locked bonus progress";
      state.loading = false;
    });
  },
});


export default bonusSlice.reducer;